export const useValidationMessage = (key: string, value?: number): string => {
  const { t } = useI18n()
  const messageKey = `validation.${key}`

  return value !== undefined && value !== null ? t(messageKey, { value }) : t(messageKey)
}
